<template>
    <div>
        <h1>포인트 사용</h1>

        <section class="mt-4">
            <p><b>* 개발자에게 제공되는 예제입니다.</b></p>
            <p>트랜잭션 형태로 기능이 제공됩니다. 포인트 차감이 필요한 <b>시스템 로직</b>에 추가해주시면 됩니다.</p>
            <div>
                <b>1. transaction.use()</b>
                <p>회원정보, 사용금액, 로그를 파라미터로 전달합니다.<br/>임시차감을 시도하며 보유포인트가 부족시 throw 예외를 발생시킵니다.</p>
            </div>
            <div>
                <b>2. transaction.commit()</b>
                <p>다른작업 후 문제사항이 없다면, 포인트 변동을 확정하고 히스토리를 기록합니다.</p>
            </div>
            <div>
                <b>3. transaction.rollback()</b>
                <p>문제가 발생한경우 포인트를 원래상태로 복구하고, 해당 내용을 확정하지 않습니다.</p>
            </div>

            <prism-editor v-model="section1.exampleCode" line-numbers class="rounded"></prism-editor>
        </section>
    </div>
</template>

<script>
import exampleLayout from '@/components/developer/example-layout.vue'
import prismEditor from '@/components/developer/prism-editor.vue'

export default {
    components: {
        exampleLayout,
        prismEditor,
    },
    data(){
        return {
            section1: {
                exampleCode: `import { Point } from \"@/models/user\";\n\nconst usePoint = async () => {\n    var transaction = new Point.Transaction();\n    try{\n        let filter = { /*_id: _user */ username: \"uxidev\" };\n        let amount = 1000;\n        let log = {\n            _order: null,\n            remark: \"식대비용사용\"\n        };\n\n        await transaction.use(filter, amount, log);\n        /*\n         * 다른 작업\n         */\n        await transaction.commit();\n    }\n    catch(error){\n        console.error(error);\n        await transaction.rollback();\n        throw error;\n    }\n};\n\nusePoint();`
            }
        }
    },
}
</script>